export const COMMUNITY_SUBSCRIPTIONS_RESET_STATE = 'COMMUNITY_SUBSCRIPTIONS_RESET_STATE';
export const COMMUNITY_SUBSCRIPTIONS_CURRENT_ITEM = 'COMMUNITY_SUBSCRIPTIONS_CURRENT_ITEM';

export const COMMUNITY_SUBSCRIPTIONS_REQUEST_LOADING = 'COMMUNITY_SUBSCRIPTIONS_REQUEST_LOADING';
export const COMMUNITY_SUBSCRIPTIONS_REQUEST_SUCCESS = 'COMMUNITY_SUBSCRIPTIONS_REQUEST_SUCCESS';
export const COMMUNITY_SUBSCRIPTIONS_REQUEST_FAILED = 'COMMUNITY_SUBSCRIPTIONS_REQUEST_FAILED';

export const COMMUNITY_SUBSCRIPTIONS_CURRENT_ACTION = 'COMMUNITY_SUBSCRIPTIONS_CURRENT_ACTION';
export const COMMUNITY_SUBSCRIPTIONS_RESET_ACTION = 'COMMUNITY_SUBSCRIPTIONS_RESET_ACTION';